/**
 * Riitan pesula – pöytäkartan renderöinti storefrontiin.
 * Hakee layoutin cashback-sovelluksesta (/apps/cashback/floor-plan.json).
 */
(function () {
  'use strict';

  var Layout = window.RiFloorPlanLayout;
  if (!Layout) return;

  var DEFAULT_FLOOR_PLAN_URL = '/apps/cashback/floor-plan.json';

  function pct(value, total) {
    return (value / total * 100) + '%';
  }

  function createCell(place, activeTable) {
    var el = document.createElement('span');
    el.className = 'ri-floor-plan__abs-cell';
    el.textContent = String(place.id);
    el.setAttribute('data-table', String(place.id));
    if (activeTable && Number(activeTable) === Number(place.id)) {
      el.classList.add('is-active');
    }
    return el;
  }

  function createLabel(item, canvas) {
    var el = document.createElement('div');
    el.className = 'ri-floor-plan__abs-label';
    if (item.variant) {
      el.classList.add('ri-floor-plan__abs-label--' + item.variant);
    }
    el.textContent = item.label;
    el.style.left = pct(item.x, canvas.width);
    el.style.top = pct(item.y, canvas.height);
    el.style.width = pct(item.w, canvas.width);
    el.style.height = pct(item.h, canvas.height);
    return el;
  }

  function renderAbsolute(canvas, layout, activeTable) {
    var canvasSize = layout.canvas || { width: 788, height: 370 };
    var map = document.createElement('div');
    map.className = 'ri-floor-plan__abs-map';
    map.style.aspectRatio = canvasSize.width + ' / ' + canvasSize.height;

    (layout.decor || []).forEach(function (item) {
      if (item.type !== 'circle') return;
      var decor = document.createElement('div');
      decor.className = 'ri-floor-plan__abs-decor';
      decor.style.left = pct(item.cx - item.r, canvasSize.width);
      decor.style.top = pct(item.cy - item.r, canvasSize.height);
      decor.style.width = pct(item.r * 2, canvasSize.width);
      decor.style.height = pct(item.r * 2, canvasSize.height);
      map.appendChild(decor);
    });

    (layout.labels || []).forEach(function (item) {
      map.appendChild(createLabel(item, canvasSize));
    });

    (layout.places || []).forEach(function (place) {
      var wrap = document.createElement('div');
      wrap.className = 'ri-floor-plan__abs-place';
      wrap.style.left = pct(place.x, canvasSize.width);
      wrap.style.top = pct(place.y, canvasSize.height);
      wrap.style.width = pct(place.w, canvasSize.width);
      wrap.style.height = pct(place.h, canvasSize.height);
      wrap.appendChild(createCell(place, activeTable));
      map.appendChild(wrap);
    });

    canvas.appendChild(map);
    return map;
  }

  function scrollActiveIntoView(root, smooth) {
    var active = root.querySelector('.ri-floor-plan__abs-cell.is-active');
    if (!active) return;
    window.requestAnimationFrame(function () {
      active.scrollIntoView({
        inline: 'center',
        block: 'nearest',
        behavior: smooth ? 'smooth' : 'auto'
      });
    });
  }

  function setActiveTable(root, tableNum, scroll) {
    var map = root.querySelector('.ri-floor-plan__abs-map');
    if (!map) return;

    map.querySelectorAll('.ri-floor-plan__abs-cell').forEach(function (cell) {
      var match = tableNum && Number(cell.getAttribute('data-table')) === Number(tableNum);
      cell.classList.toggle('is-active', !!match);
    });

    if (scroll && tableNum) {
      scrollActiveIntoView(root, true);
    }
  }

  function cardFromEvent(event, scope) {
    var card = event.target.closest('.ri-product-card, .ri-product-card-wrapper');
    if (!card || !scope.contains(card)) return null;
    return card;
  }

  function bindInteractive(root) {
    if (root.dataset.interactiveBound === '1') return;
    root.dataset.interactiveBound = '1';

    var scope = root.closest('.ri-home') || document;

    scope.addEventListener('mouseover', function (event) {
      var card = cardFromEvent(event, scope);
      if (!card) return;
      setActiveTable(root, card.getAttribute('data-table-number') || '', false);
    });

    scope.addEventListener('focusin', function (event) {
      var card = cardFromEvent(event, scope);
      if (!card) return;
      setActiveTable(root, card.getAttribute('data-table-number') || '', false);
    });

    scope.addEventListener('click', function (event) {
      var card = cardFromEvent(event, scope);
      if (!card) return;
      var tableNum = card.getAttribute('data-table-number');
      if (!tableNum) return;
      setActiveTable(root, tableNum, true);
      var mapSection = root.closest('.ri-home__map') || root;
      mapSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    if (scope.classList.contains('ri-home')) {
      scope.addEventListener('mouseleave', function (event) {
        if (!scope.contains(event.relatedTarget)) {
          setActiveTable(root, root.dataset.activeTable || '', false);
        }
      });
    }
  }

  function fetchLayout(root) {
    var url = root.getAttribute('data-floor-plan-url') || DEFAULT_FLOOR_PLAN_URL;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('floor plan fetch failed');
        return response.json();
      })
      .then(function (layout) {
        if (!layout || !Array.isArray(layout.places)) throw new Error('invalid floor plan');
        return layout;
      })
      .catch(function () {
        if (Layout.getRiitanFloorPlanLayout) {
          return Layout.getRiitanFloorPlanLayout();
        }
        throw new Error('no floor plan fallback');
      });
  }

  function renderRoot(root) {
    var canvas = root.querySelector('.ri-floor-plan__canvas');
    if (!canvas || canvas.dataset.rendered === '1') return Promise.resolve();
    canvas.dataset.rendered = '1';

    var activeTable = root.dataset.activeTable || '';

    return fetchLayout(root).then(function (layout) {
      renderAbsolute(canvas, layout, activeTable);

      if (activeTable) {
        scrollActiveIntoView(root, true);
      }

      if (root.hasAttribute('data-ri-floor-plan-interactive')) {
        bindInteractive(root);
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-ri-floor-plan]');
    if (!roots.length) return;

    Promise.all(Array.prototype.map.call(roots, renderRoot)).catch(function () {
      // Hiljainen fallback — staattinen layout yritetään fetchLayoutissa
    });
  }

  window.RiFloorPlan = {
    setActiveTable: function (root, tableNum, scroll) {
      if (typeof root === 'string') {
        root = document.querySelector(root);
      }
      if (root) {
        setActiveTable(root, tableNum, scroll);
      }
    },
    refresh: function (root) {
      if (typeof root === 'string') {
        root = document.querySelector(root);
      }
      if (!root) return Promise.resolve();
      var canvas = root.querySelector('.ri-floor-plan__canvas');
      if (canvas) {
        canvas.dataset.rendered = '0';
        canvas.innerHTML = '';
      }
      return renderRoot(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
